<app-logo-area
  [breadcrumbs]="[{'display': 'Content Platform', commands: null}]"></app-logo-area>
<main>

  <app-headline-section [title]="'Aspera Connectors'">
  </app-headline-section>

  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8">
          <p class="cl-p-large">
            Every Aspera share we deliver to. Open one to browse its files and follow its transfers.
          </p>
        </div>
      </div>
    </div>
  </section>

  @if (error()) {
    <section class="cl-section cl-section-regular">
      <div class="container"><div class="row"><div class="col-12">
        <p class="cl-p-regular cl-color-brick">Could not load the Aspera endpoints: {{ error() }}</p>
      </div></div></div>
    </section>
  }

  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="cl-table-scroll">
            <table class="cl-table-data">
              <thead>
                <tr>
                  <th class="cl-table-head">Endpoint</th>
                  <th class="cl-table-head">Share</th>
                  <th class="cl-table-head">Delivers</th>
                  <th class="cl-table-head">Fixed egress IP</th>
                </tr>
              </thead>
              <tbody>
                @if (loading()) {
                  <tr class="cl-tr-no-data"><td colspan="100"><div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div></td></tr>
                }
                @for (endpoint of endpoints(); track endpoint.id) {
                  <tr>
                    <td>
                      <a [routerLink]="['/o', organization()?.id, 'aspera-endpoints', endpoint.id]">{{ endpoint.name }}</a>
                      <p>{{ endpoint.id }}</p>
                    </td>
                    <td>{{ endpoint.share }}</td>
                    <td>{{ endpoint.delivers }}</td>
                    <td>{{ endpoint.fixedEgressIp || '—' }}</td>
                  </tr>
                }
                @if (!loading() && endpoints().length === 0 && !error()) {
                  <tr class="cl-tr-no-data"><td colspan="100">No Aspera endpoints are available to you.</td></tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
